import { Component, OnInit, NgZone } from '@angular/core';
import { ApiService } from '../services/api/api.service';


@Component({
  selector: 'app-about',
  templateUrl: './about.page.html',
  styleUrls: ['./about.page.scss'],
})
export class AboutPage implements OnInit {
  AboutUsData:any = ''
  BannerImg:any = ''
  constructor(public api: ApiService,public zone: NgZone) { }

  ngOnInit() {

    this.zone.run(() => {
      // Get the information from the API
      try {  
        this.api.getAboutContent().subscribe((result:any) => {
          if(result.status == true){
            if(result.data){
              this.AboutUsData = result.data.about_text
              this.BannerImg = result.data.about_icon
            }
          }
        },(err)=>{
          console.log(err)
        });
      }
      catch (error) {
        console.error('Here is the error message', error);
      }
    })
  }

  openUrl(value:any){
    if(value == 'twitter'){
      window.open("https://twitter.com/santhaif2h",'_system', 'location=yes');
    }
    else if(value == 'linkedin'){
      window.open("http://www.linkedin.com/in/santhaif2h",'_system', 'location=yes');
    }
    else if(value == 'instagram'){
      window.open("https://www.instagram.com/santhaif2h/",'_system', 'location=yes');
    }
    else if(value == 'facebook'){
      window.open("https://www.facebook.com/Santhaif2h",'_system', 'location=yes');
    }
    else if(value == 'whatsapp'){
      let URL:any = "whatsapp://send?phone=91" + '8072449191';
      window.open(URL)
    }
  }

}
